import Vue from 'vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {
    faLock,faCircleXmark, faCartShopping, faCheck,faTable,faPrint,faArrowRotateLeft,faPowerOff,faBars,faArrowsRotate,faMoneyBill,faReceipt,faEye,faBell,faArrowLeft,faGears,
    faHome,faBoxesStacked,faPenToSquare,faChevronUp,faMagnifyingGlass,faDownload,faComputer,faEdit,faAdd,faInfoCircle,faChevronDown,faMinus,faTrash

} from '@fortawesome/free-solid-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(
    faLock,faDownload,faComputer,faCartShopping,faMagnifyingGlass,faChevronUp,faCircleXmark,faAdd,faInfoCircle,faMinus,faTrash, faChevronDown,faEdit,faCheck,faTable,faPrint,faArrowRotateLeft,faPowerOff,faBars,faArrowsRotate,faMoneyBill,faReceipt,faEye,faBell,faArrowLeft,faGears,faHome,faBoxesStacked,faPenToSquare
)